import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ResetPassword } from "../models/ResetPassword";

@Injectable()
export class ResetPasswordService {

    url = `${environment.apiBaseUrl}/reset`;

    constructor(private http: HttpClient) { }

    request(email: string) {
        return this.http.get(`${this.url}?email=${email}`);
    }

    reset(item: ResetPassword) {
        return this.http.post(this.url, item);
    }
}